<div class="card border-0 my-3 w-100">
    <div class="card-body">
        <ng-content></ng-content>
    </div>
</div>
